/**
 * UuidUtils
 * UUID generation utilities
 * Matches Flutter implementation: uuid package
 */

/**
 * Generate UUID v4 (random)
 * Used for unique message IDs
 * Uses crypto.randomUUID() which is available in modern browsers
 */
export function generateUuidV1(): string {
  // Use crypto.randomUUID() if available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback: simple UUID v4 implementation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
